<template>
  <div class="map-style point">
    <div class="map-style__block">
      <classes-color-picker
        @change-property="changeProperty"
        @change-classes="changeClasses"
        @change-strings="changeStrings"
        :id="id"
        :layer-style="layerStyle.style"
        :layer-controller="layerController"
        property="fill"
        title="Цвет"
      />
    </div>
    <div class="map-style__block">
      <polygon-outline-picker
        @change-property="changeBorder"
        :id="id"
        :layer-style="layerStyle.borderStyle"
        :layer-controller="layerController"
        title="Обводка"
      />
    </div>
    <div class="map-style__block">
      <fill-extrusion-picker
        :id="id"
        :layer-style="layerStyle"
        :layer-controller="layerController"
        :style-controller="styleController"
        title="Высота"
      />
    </div>
    <div class="map-style__block">
      <popup-fields-picker
        :id="id"
        :layer-style="layerStyle"
        :layer-controller="layerController"
        title="Информация"
      />
    </div>
  </div>
</template>

<script>
import ClassesColorPicker from "../input-sources/classes-color-picker";
import PolygonOutlinePicker from "../input-sources/polygon-outline-picker";
import FillExtrusionPicker from "../input-sources/fill-extrusion-picker";
import PopupFieldsPicker from "../input-sources/popup-fields-picker";

export default {
  props: ["id", "layer-style", "layer-controller", "style-controller"],
  components: {
    ClassesColorPicker,
    PolygonOutlinePicker,
    FillExtrusionPicker,
    PopupFieldsPicker
  },
  methods: {
    changeProperty(payload) {
      this.$emit("change-property", payload);
    },
    changeClasses(payload) {
      this.$emit("change-classes", payload);
    },
    changeStrings(payload) {
      this.$emit("change-strings", payload);
    },
    changeBorder({ type, field }) {
      this.styleController.changePolygonBorder(this.id, type, field);
    }
  }
};
</script>

<style lang="scss"></style>
